export function clearTextSelection() {
  window.getSelection?.()?.removeAllRanges?.();
}
